exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#login-main {\n    width: 100% !important;\n}\n#login-retry {\n    text-transform: unset !important;\n    padding-left: unset !important;\n}\n", ""]);

// exports
